import { render, staticRenderFns } from "./CountDownTimer.vue?vue&type=template&id=856ff470&scoped=true&"
import script from "./CountDownTimer.vue?vue&type=script&lang=js&"
export * from "./CountDownTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856ff470",
  null
  
)

export default component.exports